import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function StockOutManual() {
  const [kind, setKind] = useState("ingredient");
  const [options, setOptions] = useState({ locations: [], ingredients: [] });
  const [products, setProducts] = useState([]);
  const [locationId, setLocationId] = useState("");
  const [entityId, setEntityId] = useState("");
  const [qty, setQty] = useState("1");
  const [reason, setReason] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    Promise.all([
      api.get("/stock-out/options"),
      api.get("/products"),
    ]).then(([a, b]) => {
      setOptions(a.data || { locations: [], ingredients: [] });
      setProducts(Array.isArray(b.data) ? b.data : b.data?.products || []);
    }).catch(() => setMessage("Gagal memuat pilihan barang dan lokasi."));
  }, []);

  const locations = options.locations || [];
  const entities = kind === "ingredient" ? options.ingredients : products;

  async function submit(e) {
    e.preventDefault();
    setMessage("");
    if (!locationId || !entityId || !(Number(qty) > 0) || !reason.trim()) {
      setMessage("Lengkapi lokasi, barang, jumlah positif, dan alasan.");
      return;
    }
    const loc = locations.find((x) => x.id === locationId);
    if (kind === "product" && loc?.type !== "outlet") {
      setMessage("Penyesuaian produk hanya mendukung outlet.");
      return;
    }
    setBusy(true);
    try {
      if (kind === "ingredient") {
        await api.post("/ingredients/stock-adjust", {
          ingredient_id: entityId,
          location_type: loc.type,
          location_id: locationId,
          delta: -Number(qty),
          reason: reason.trim(),
        });
      } else {
        await api.post("/products/stock-adjust", {
          product_id: entityId,
          outlet_id: locationId,
          delta: -Number(qty),
          reason: reason.trim(),
        });
      }
      setMessage("Penyesuaian stok berhasil dicatat.");
      setEntityId("");
      setQty("1");
      setReason("");
    } catch (err) {
      setMessage(err.response?.data?.detail || "Gagal mencatat pengeluaran stok.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} className="space-y-4 rounded-lg border bg-white p-5">
      <h2 className="text-lg font-semibold">Pengeluaran Manual</h2>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <label className="space-y-1 text-sm">Jenis barang
          <select className="w-full rounded-md border p-2" value={kind}
            onChange={(e) => { setKind(e.target.value); setEntityId(""); }}>
            <option value="ingredient">Bahan baku</option>
            <option value="product">Produk jadi</option>
          </select>
        </label>
        <label className="space-y-1 text-sm">Lokasi
          <select className="w-full rounded-md border p-2" value={locationId}
            onChange={(e) => setLocationId(e.target.value)} required>
            <option value="">Pilih lokasi</option>
            {locations.filter((x) => kind === "ingredient" || x.type === "outlet")
              .map((x) => <option key={x.id} value={x.id}>{x.name} ({x.type})</option>)}
          </select>
        </label>
        <label className="space-y-1 text-sm">Barang
          <select className="w-full rounded-md border p-2" value={entityId}
            onChange={(e) => setEntityId(e.target.value)} required>
            <option value="">Pilih barang</option>
            {entities.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
          </select>
        </label>
        <label className="space-y-1 text-sm">Jumlah keluar
          <input className="w-full rounded-md border p-2" type="number" min="0.001"
            step="any" value={qty} onChange={(e) => setQty(e.target.value)} required />
        </label>
      </div>
      <label className="block space-y-1 text-sm">Alasan pengeluaran
        <textarea className="w-full rounded-md border p-2" rows={2}
          value={reason} onChange={(e) => setReason(e.target.value)}
          placeholder="Contoh: barang rusak, kedaluwarsa, atau pemakaian internal" required />
      </label>
      {message && <p className="text-sm">{message}</p>}
      <button disabled={busy} className="rounded-md bg-black px-4 py-2 text-white disabled:opacity-50">
        {busy ? "Menyimpan..." : "Catat Pengeluaran"}
      </button>
    </form>
  );
}
